import { toast } from 'react-toastify';
import { i18n } from '../translate/i18n';

const toastError = (err) => {
	const rawErrorMsg = err.response?.data?.message || err.response?.data?.error;
	const errorMsg =
		typeof rawErrorMsg === 'string'
			? rawErrorMsg
			: rawErrorMsg?.message || rawErrorMsg?.sqlMessage || '';
	console.log(err);
	if (errorMsg) {
		if (errorMsg === 'ERR_COMPANY_INACTIVE') {
			toast.error('Esta empresa está inativa. Entre em contato com o suporte.', { toastId: errorMsg });
			return;
		}
		if (errorMsg === 'ERR_USER_INACTIVE') {
			toast.error('Sua conta está inativa. Entre em contato com o administrador da empresa.', { toastId: errorMsg });
			return;
		}
		if (
			errorMsg === 'ERR_EMAIL_SEND_FAILED' ||
			(errorMsg && errorMsg.startsWith('ERR_EMAIL_SEND_FAILED'))
		) {
			const message = i18n.exists('backendErrors.ERR_EMAIL_SEND_FAILED')
				? i18n.t('backendErrors.ERR_EMAIL_SEND_FAILED')
				: 'Não foi possível enviar o e-mail. Tente novamente mais tarde ou contate o suporte.';
			toast.error(message, { toastId: 'ERR_EMAIL_SEND_FAILED', autoClose: 6000 });
			return;
		}
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else if (errorMsg.includes('OTHER_OPEN_TICKET')) {
			toast.error(i18n.t('Há outro ticket aberto para este contato'), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		toast.error('An error occurred!');
	}
};

export default toastError;
